class ReservedProductsList extends HTMLElement {
  reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');

  connectedCallback() {
    this.reservedProductsList = this.querySelector('.reserved-products-list');
    this.reserveProductsDialog = document.querySelector('reserve-products-dialog');
    this.reserveProductsDialogCount = this.reserveProductsDialog?.querySelector(
      '.reserve-products-dialog__count'
    );

    this.fetchProducts();

    this.unsubscribeQuantityChange = subscribe('quantity:change', ({ productId, quantity }) => {
      this.updateProductQuantity(productId, quantity);
    });

    this.unsubscribeProductRemoved = subscribe('product-removed', ({ lineItemId }) => {
      this.handleProductRemoved(lineItemId);
    });
  }

  disconnectedCallback() {
    this.unsubscribeQuantityChange();
    this.unsubscribeProductRemoved();
  }

  handleProductRemoved(lineItemId) {
    const listItem = this.querySelector(`.reserved-products-list__item--${lineItemId}`);
    listItem?.remove();

    const updated = this.reservedProducts.filter(({ id }) => id !== lineItemId);
    sessionStorage.setItem('reservedProducts', JSON.stringify(updated));
    this.reservedProducts = updated;

    if (this.reserveProductsDialogCount) {
      this.reserveProductsDialogCount.textContent = updated.length;
    }

    document.querySelector('reserved-products-form')?.createTextareaValue();
  }

  updateProductQuantity(productId, quantity) {
    const product = this.reservedProducts.find((p) => p.id === productId);
    if (!product) return;

    product.quantity = parseInt(quantity, 10);
    sessionStorage.setItem('reservedProducts', JSON.stringify(this.reservedProducts));
    document.querySelector('reserved-products-form')?.createTextareaValue();
  }

  async fetchProducts() {
    const productPromises = this.reservedProducts.map(async ({ url, id, quantity }) => {
      try {
        const response = await fetch(`${url}?view=line-item`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const lineItemCard = html.querySelector('.line-item-card');
        const { lineItemId } = lineItemCard.dataset;

        return {
          lineItemId,
          storedId: id,
          storedQuantity: quantity || 1,
          html: lineItemCard.outerHTML,
        };
      } catch (error) {
        console.error(error);
        return null;
      }
    });

    const products = await Promise.all(productPromises);

    products.forEach((product) => {
      if (!product) return;

      const reservedItem = document.createElement('li');
      reservedItem.className = `reserved-products-list__item reserved-products-list__item--${product.lineItemId} pt-7`;
      reservedItem.innerHTML = product.html;
      this.reservedProductsList.appendChild(reservedItem);

      // Apply the stored quantity from sessionStorage to the quantity input
      const quantityInput = reservedItem.querySelector('quantity-input input');
      if (!quantityInput || !product.storedQuantity) return;
      quantityInput.value = product.storedQuantity;
    });
  }

  removeProduct() {
    const reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');
    const { lineItemId } = this.lineItemCard.dataset;

    // Find the product in the reservedProducts array
    const product = reservedProducts.find((product) => product.id === lineItemId);

    // Find the index of the product
    const index = reservedProducts.indexOf(product);

    // Remove it from the array
    reservedProducts.splice(index, 1);

    // Save the updated array to the sessionStorage
    sessionStorage.setItem('reservedProducts', JSON.stringify(reservedProducts));

    this.removeProductFromList(lineItemId);
    this.updateTextareaValue();

    // Update the count in the reserveProductsDialog
    this.reserveProductsDialogCount.textContent = reservedProducts.length;
  }

  removeProductFromList(lineItemId) {
    // Find the product in the reservedProductsList and remove it
    const productNode = this.reservedProductsList.querySelector(
      `.reserved-products-list__item--${lineItemId}`
    );
    productNode.remove();
  }

  updateTextareaValue() {
    const reservedProductsForm = document.querySelector('reserved-products-form');
    if (!reservedProductsForm) return;
    reservedProductsForm.reservedProducts = JSON.parse(
      sessionStorage.getItem('reservedProducts') || '[]'
    );
    reservedProductsForm.createTextareaValue();
  }
}

customElements.define('reserved-products-list', ReservedProductsList);
